export const MARKUP_RATE_DECIMAL_POSITIONS = 1;
export const EXCHANGE_RATE_DECIMAL_POSITIONS = 4;
export const INTERNATIONAL_CARD_FEE = 0.03;
